import React from "react";
import {
   PricingSectionPlansBlock,
   PricingSectionTitleBlock,
} from "./components";

const PricingSection: React.FC = () => {
   return (
      <section id="plans">
         <PricingSectionTitleBlock />
         <PricingSectionPlansBlock />
      </section>
   );
};

export default PricingSection;
